import { render, staticRenderFns } from "./previewWord.vue?vue&type=template&id=49b004f3&scoped=true"
import script from "./previewWord.vue?vue&type=script&lang=js"
export * from "./previewWord.vue?vue&type=script&lang=js"
import style0 from "./previewWord.vue?vue&type=style&index=0&id=49b004f3&prod&lang=scss&scoped=true"
import style1 from "./previewWord.vue?vue&type=style&index=1&id=49b004f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b004f3",
  null
  
)

export default component.exports